import axios from "axios";
import { Belt } from "../types/belt";
import { API_CONFIG } from "config/apiConfig";

export const getBelts = async (): Promise<Belt[]> => {
  const res = await axios.get(`${API_CONFIG.BASE_URL}/Belt/GetBelts`);
  return res.data;
};

export const saveBelts = async (belts: Belt[]): Promise<void> => {
  await axios.post(`${API_CONFIG.BASE_URL}/Belt/SaveBelts`, belts);
}; 